import { CFormLabel, CFormTextarea } from '@coreui/react';
import PropTypes from 'prop-types';

const Textarea = (props) => {
    const { field, form, type, label, disabled, isRequired, attributes = {} } = props;
    const placeholder = props.placeholder ?? label;
    const { name } = field;
    const { errors, touched } = form;
    let showError = errors[name] && touched[name];
    if (errors[name] && props.title) {
        errors[name] = errors[name].replace(name, props.title);
    }
    return (
        <>
            <div className="mb-3">
                <CFormLabel htmlFor={name}>
                    {label} {isRequired ? <span style={{ color: 'red' }}>*</span> : null}
                </CFormLabel>
                <CFormTextarea
                    id={name}
                    rows={4}
                    {...field}
                    type={type}
                    disabled={disabled}
                    placeholder={placeholder}
                    {...attributes}
                />
                {showError && <p className={'text-danger'}>{errors[name]}</p>}
            </div>
        </>
    );
};

Textarea.propTypes = {
    field: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
    type: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    isRequired: PropTypes.bool,
};

Textarea.defaultProps = {
    type: 'text',
    label: '',
    disabled: false,
    isRequired: false,
};

export default Textarea;
